import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl"
import { Link } from "react-router-dom";
import JoditReact from "jodit-react";
import '../../admin/announcement/Mail.css'
import { useAuth } from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
const AddBlog = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [title, setTitle] = useState('')
    const bodyContentRef = useRef(null);
    const [message, setMessage] = useState("")
    const [processing, setProcessing] = useState(false)
    const imgFileRef = useRef()
    const [imgFile, setImgFile] = useState(null)
    const [editorKey, setEditorKey] = useState(Date.now());
    const [active,setActive]=useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setMessage(false);
        }, 4000);
        return () => clearTimeout(timer);
    }, [message]);
    const editorConfig = {
        readonly: false,
        tabIndex: 1,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_clear_html",
        placeholder: "Type your description here ...",
        beautyHTML: true,
        toolbarButtonSize: "small",
        addNewLine: false,
        buttons: [
            "bold",
            "italic",
            'subscript',
            'superscript',
            "|",
            "ul",
            "ol",
            "link",
            "|",
            "font",
            "fontsize",
            "brush",
            "paragraph",
            "|",
            "table",
            "|",
            "left",
            "center",
            "right",
            "justify",
            "|",
            "undo",
            "redo",
            "|",
            "hr",
            "fullsize",
        ],
        extraButtons: [
            // {
            //     name: "image",
            //     tooltip: "Insert Image",
            //     exec: (editor) => {
            //         const input = document.createElement("input");
            //         input.type = "file";
            //         input.accept = "image/*";
            //         input.addEventListener("change", async (e) => {
            //             const file = e.target.files[0]; // Get the file from the input

            //             if (file) {
            //                 // Create FormData to send the file to the backend
            //                 const formData = new FormData();
            //                 formData.append("file", file); // Append the image file

            //                 try {
            //                     // Send the image to the backend server
            //                     const response = await axios.post(`${baseUrl}/question/upload-image`, formData, {
            //                         headers: {
            //                             "Content-Type": "multipart/form-data", // Ensure the correct content type
            //                         },
            //                     });

            //                     const imageUrl = response.data.url;

            //                     // Insert the uploaded image URL into the Jodit editor
            //                     editor.selection.insertImage(imageUrl);
            //                 } catch (err) {
            //                     console.error("Error uploading image:", err);
            //                 }
            //             }
            //         });
            //         input.click();
            //     },
            // },
        ],
        disablePlugins: ["speech"],
        toolbarAdaptive: false,
    }

    const handleBodyContent = (newContent) => {
        if (bodyContentRef.current) {
            // Ensure that the ref is updated with new content, even when it's empty
            if (newContent === "") {
                bodyContentRef.current = "<p></p>"; // If the content is cleared, make sure the ref is set to an empty string
            } else {
                bodyContentRef.current = newContent; // Otherwise, set it to the new content
            }
        }
    }

    const handleSubmit = (e) => {
        const detail = bodyContentRef.current?.value;
        if (title === '') {
            toast.error('Please enter Title')
            return
        }
        if (imgFile === null) {
            toast.error('Please upload Valid Image file')
            return
        }

        if (bodyContentRef.current === "<p><br></p>" || bodyContentRef.current === "<p></p>") {
            toast.error("Please type some blog details")
            return
        }
        const formData = new FormData();
        formData.append('imgFile', imgFile[0]);
        formData.append('title', title);
        formData.append('detail', bodyContentRef.current);
        formData.append('show',active)

        setProcessing(true)
        axios.post(`${baseUrl}/blog/add`, formData)
            .then(res => {
                toast.success(res.data.message);
                setEditorKey(Date.now())
                setProcessing(false)
                setTitle("");
                setImgFile(null);
                bodyContentRef.current = "<p></p>"
                imgFileRef.current.value = "";

            })
            .catch(err => {
                console.log(err);
                toast.error(err?.response?.data?.message || 'Something went wrong')
                setProcessing(false)
            })

    }

    const handleImgFile = (e) => {
        const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const maxSizeInBytes = 2 * 1024 * 1024;
        if (validFileTypes.includes(e.target.files[0].type) &&
            e.target.files[0].size <= maxSizeInBytes) {
            setImgFile(e.target.files)
            toast.success('Image Loaded')
        }
        else {
            toast.error('Invalid file. Only Image files (jpeg,jpg,png) under 2MB are allowed.')
            setImgFile(null);
            imgFileRef.current.value = ""
        }

    }

    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
                <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Add Blog
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div
                    className={`container ${styles.container}`}>
                    <div className="bg-white p-4">
                        <h4>Add Blog</h4>
                        <div className="row mb-3">
                            <div className="col-lg-6">
                                <label htmlFor="title" className="form-label">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="title"
                                    placeholder="Enter Title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-6">
                                <label htmlFor="imgFile" className="form-label">
                                    Image
                                </label>
                                <input
                                    id="imgFile"
                                    ref={imgFileRef}
                                    onChange={handleImgFile}
                                    type="file"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="body" className="form-label">
                                    Detail
                                </label>
                                <JoditReact
                                    key={editorKey}
                                    ref={bodyContentRef}
                                    config={editorConfig}
                                    onChange={handleBodyContent}
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-lg-6">
                                <label htmlFor="status" className="form-label">
                                    Status :                   {
                                        active ?
                                            <label htmlFor="active" className="form-label">
                                                Published
                                            </label> :
                                            <label htmlFor="inactive" className="form-label">
                                                Draft
                                            </label>
                                    }
                                    <input checked={active} onChange={() => setActive(!active)} className="ml-2" type="checkbox" />
                                </label>
                            </div>
                        </div>
                        {
                            message &&
                            <div
                                className="alert alert-warning alert-dismissible fade show mt-3"
                                role="alert"
                            >
                                {message}
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="alert"
                                    aria-label="Close"
                                    onClick={() => setMessage(false)}
                                ></button>
                            </div>
                        }
                        <button disabled={processing} onClick={handleSubmit} className="btn btn-primary mt-4">
                            {processing ? 'Loading...' : 'Submit'}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AddBlog;
